import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IAdvisor } from '../../shared/models/advisor.models';
import { ISearchInvestorHouseholdResults } from '../../shared/models/investor.models';
import { IUser } from '../../shared/models/identity.models';

@Injectable({
  providedIn: 'root',
})
export class ServicerService {
  private readonly baseUrl = '/api/servicer';

  constructor(private http: HttpClient) { }

  private replaceSlashes(str: string): string {
    return str.replace(/\/|\\/g, "-");
  }

  getAllAdvisors(): Observable<IAdvisor[]> {
    return this.http.get<IAdvisor[]>(`${this.baseUrl}/getalladvisors`);
  }

  updateAdvisor(model: IAdvisor): Observable<IAdvisor> {
    return this.http.post<IAdvisor>(`${this.baseUrl}/updateadvisor`, model);
  }

  getAdvisors(companyGroupId: number): Observable<IAdvisor[]> {
    return this.http.get<IAdvisor[]>(`${this.baseUrl}/getadvisors/${companyGroupId}`);
  }

  getAdvisor(advisorId: number): Observable<IAdvisor> {
    return this.http.get<IAdvisor>(`${this.baseUrl}/getadvisor/${advisorId}`);
  }

  createAdvisor(model: IAdvisor): Observable<{ data: IAdvisor; warnings: any[] }> {
    return this.http.post<{ data: IAdvisor; warnings: any[] }>(
      `${this.baseUrl}/createadvisor`,
      model
    );
  }

  enableAdvisorSL(model: IAdvisor): Observable<IAdvisor> {
    return this.http.post<IAdvisor>(`${this.baseUrl}/enableadvisorsl`, model);
  }

  reactivateAdvisorSL(model: IAdvisor): Observable<IAdvisor> {
    return this.http.post<IAdvisor>(`${this.baseUrl}/reactivateadvisorsl`, model);
  }

  disableAdvisorSL(model: IAdvisor): Observable<IAdvisor> {
    return this.http.post<IAdvisor>(`${this.baseUrl}/disableadvisorsl`, model);
  }

  lockAdvisorSL(model: IAdvisor): Observable<IAdvisor> {
    return this.http.post<IAdvisor>(`${this.baseUrl}/lockadvisorsl`, model);
  }

  unlockAdvisorSL(model: IAdvisor): Observable<IAdvisor> {
    return this.http.post<IAdvisor>(`${this.baseUrl}/unlockadvisorsl`, model);
  }

  searchInvestorsAll(searchTerm: string, investorType: number): Observable<ISearchInvestorHouseholdResults[]> {
    const sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
    return this.http
      .get<ISearchInvestorHouseholdResults[]>(
        `/api/servicer/searchinvestorsall/${sterm}/${investorType}`
      )
      .pipe(
        map(response => {
          console.log('API searchInvestorsAll response: ' + response);
          return response;
        })  // Use RxJS `map` to extract `data`
      );
  }

  getServicers(): Observable<IUser[]> {
    return this.http.get<IUser[]>('/api/servicer/getservicers');
  }
}
